import React from 'react';
import {Route, Redirect } from 'react-router-dom';
import { isAuthenticated } from 'libs/helpers'
// import PageNotFound from 'pages/PageNotFound'

const ProtectedRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={ props => {
        if (isAuthenticated()){
            return  <Component {...props} />
        } else {
            return  <Redirect to={{pathname: '/login'}}/>
        }
        }} />
);


export default ProtectedRoute;